import useAlert from '../../../components/Alert/hooks/useAlert'
import getPartner from '../repository/getPartner'

const usePaymentInfo = () => {
  const { alertError } = useAlert()

  const fetchTipaltiUrl = async (): Promise<string> => {
    const { tipalti_url: tipaltiUrl, error } = await getPartner()

    if (error) {
      alertError('Failed to load the Payment Info')
      return ''
    }

    return tipaltiUrl
  }

  return {
    fetchTipaltiUrl
  }
}

export default usePaymentInfo
